import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Как получить 50 000 бьютисов?',
      answer: 'Просто пройди короткий опрос о работе Золотого Яблока, ответь на все вопросы честно, и ты автоматически получишь доступ к награде. После завершения опроса нажми кнопку "Забрать Награду" в соответствующем разделе.'
    },
    {
      question: 'Сколько раз можно проходить опрос?',
      answer: 'Ты можешь проходить опрос сколько угодно раз! Однако награда в виде 50 000 бьютисов выдаётся один раз за первое успешное прохождение опроса. Это сделано для честного распределения наград между всеми участниками.'
    },
    {
      question: 'Сколько времени занимает опрос?',
      answer: 'Опрос состоит из 5 простых вопросов и займёт всего 2-3 минуты твоего времени. Все вопросы касаются твоего опыта покупок в Золотом Яблоке и не требуют развёрнутых ответов.'
    },
    {
      question: 'Когда я получу бьютисы?',
      answer: 'Бьютисы добавляются в твой аккаунт мгновенно после нажатия кнопки "Получить" в разделе наград. Процесс полностью автоматизирован и занимает несколько секунд.'
    },
    {
      question: 'Это действительно бесплатно?',
      answer: 'Да, абсолютно бесплатно! Никаких скрытых платежей, подписок или дополнительных условий. Просто пройди опрос и получи свою награду. Это наш способ поблагодарить тебя за обратную связь.'
    },
    {
      question: 'Нужно ли регистрироваться?',
      answer: 'Нет, регистрация не требуется. Опрос доступен сразу после загрузки страницы. Твой прогресс сохраняется автоматически в браузере, так что ты можешь вернуться в любое время.'
    }
  ];

  return (
    <section id="faq" className="py-24 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Часто Задаваемые Вопросы
          </h2>
          <p className="text-lg text-gray-600">
            Ответы на популярные вопросы об опросе и награде
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer whitespace-nowrap"
              >
                <span className="text-lg font-semibold text-gray-800 pr-4">
                  {faq.question}
                </span>
                <i className={`ri-arrow-down-s-line text-2xl text-orange-600 transition-transform duration-300 flex-shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-96' : 'max-h-0'
              }`}>
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl p-8 text-center">
          <i className="ri-question-line text-5xl text-white mb-4"></i>
          <h3 className="text-2xl font-bold text-white mb-3">
            Остались вопросы?
          </h3>
          <p className="text-white/90 mb-6">
            Свяжись с нами, и мы с радостью поможем!
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white text-orange-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Связаться с нами
          </button>
        </div>
      </div>
    </section>
  );
}
